<template>
  <div
    id="sample-reports-section"
    class="q-mx-md q-mb-md q-pa-md rounded-borders"
    :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-2'"
  >
    <div class="row items-center q-mb-md">
      <div class="col">
        <div class="text-bold" style="font-size: 15px">Example Reports</div>
        <div :class="$q.dark.isActive ? 'text-grey-4' : 'text-grey-8'">
          See HelloData in action on these sample properties &mdash; live market data, real comps.
          Ready for your own? Create a report for any address in about a minute.
        </div>
      </div>
      <div v-if="canCreatePropertyReports" class="col-auto q-ml-lg">
        <q-tooltip v-if="userUsageLimitReached" max-width="280px">
          {{ userUsageHelpText }}
        </q-tooltip>
        <q-btn
          id="sample-reports-cta"
          color="primary"
          no-caps
          unelevated
          :to="userUsageLimitReached ? undefined : { name: 'New Property Report' }"
          :disable="userUsageLimitReached"
          @click="clickedCreateOwnReport"
        >
          <q-icon name="add" class="q-mr-sm" />New Report
        </q-btn>
      </div>
    </div>
    <div class="row q-col-gutter-md">
      <div
        v-for="(sample, index) in propertyReportSamples"
        :key="sample.name"
        class="col-12 col-md"
      >
        <router-link
          :id="`sample-report-card-${index}`"
          :to="{ name: sample.name }"
          style="text-decoration: none"
        >
          <q-card
            flat
            bordered
            class="full-height sample-card"
            :class="$q.dark.isActive ? 'bg-grey-10' : 'bg-white'"
          >
            <div class="row no-wrap items-stretch">
              <div
                class="self-stretch relative-position column justify-center"
                :class="$q.dark.isActive ? 'bg-grey-9' : 'bg-grey-3'"
                style="width: 109px; min-height: 82px"
              >
                <div class="row justify-center">
                  <q-icon name="apartment" class="text-grey-5" size="lg" />
                </div>
                <q-img
                  v-if="!imageErrors[sample.subject.id]"
                  data-private
                  fit="cover"
                  no-spinner
                  referrerpolicy="no-referrer"
                  :src="imageUrl(sample.subject)"
                  class="absolute-full"
                  @error="imageErrors[sample.subject.id] = true"
                />
              </div>

              <div class="col q-pa-sm">
                <div
                  class="text-bold ellipsis"
                  :class="$q.dark.isActive ? 'text-grey-1' : 'text-grey-10'"
                >
                  {{ sample.name }}
                </div>
                <div class="ellipsis" :class="$q.dark.isActive ? 'text-grey-4' : 'text-grey-8'">
                  {{ sample.subject.street_address }}
                </div>
                <div :class="$q.dark.isActive ? 'text-grey-4' : 'text-grey-8'">
                  {{ sample.subject.city }}, {{ sample.subject.state }}
                  {{ sample.subject.zip_code }}
                </div>
                <q-badge color="orange" class="q-mb-xs">Sample</q-badge>
              </div>
            </div>
          </q-card>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { getPropertyImageUrl, propertyReportSamples } from 'common'

import { useUserStore } from '@/stores/user'

export default {
  name: 'SampleReportsSection',
  data() {
    return {
      propertyReportSamples,
      imageErrors: {} as Record<string, boolean>
    }
  },
  computed: {
    canCreatePropertyReports() {
      return useUserStore().canCreatePropertyReports
    },
    userUsageLimitReached() {
      return useUserStore().userUsageLimitReached
    },
    userUsageHelpText() {
      return useUserStore().userUsageHelpText
    }
  },
  methods: {
    imageUrl(subject: { id: string }) {
      return getPropertyImageUrl(
        subject,
        import.meta.env.VITE_API_URL,
        useUserStore().isHelloDataEmployee
      )
    },
    clickedCreateOwnReport() {
      this.$tracker.clickedNewReportButton('sample_reports_section')
    }
  }
}
</script>
<style lang="scss" scoped>
.sample-card {
  overflow: hidden;
}
.sample-card:hover {
  border-color: $primary;
}
</style>
